import { useContext, useEffect, useState } from 'react';
import Template from '../../../models/Template/Template';
import { ImagesContext } from '../../../contexts/ImagesContext';

interface Props {
  template: Template
  active: boolean
  handleSelect: (template: Template) => void
}

const BlockItem = (props: Props) => {
  const {
    template, active, handleSelect,
  } = props;

  const [blockImageUrl, setBlockImageUrl] = useState('/img/blocks/sample_block_gray.png');

  const { exchangeForUrl } = useContext(ImagesContext);

  useEffect(() => {
    if (template.img_url == null) {
      return;
    }

    if (template.img_url.trim().length === 0) {
      return;
    }

    exchangeForUrl(template.img_url).then((url) => {
      setBlockImageUrl(url);
    });
  }, [template.img_url, exchangeForUrl]);

  return (
<div className={`card blockitem ${active && 'active'}`} role="button" tabIndex={0} onClick={() => handleSelect(template)}>
    <div className="card-header d-flex position-relative">
      <div className="block-header">
        <h5 className="block-title">{template.title}</h5>
        <p className="block-sub-title">{template.description}</p>
      </div>
    </div>
    <div className="card-body d-flex">
      <div className="block-btn-bottom-left">
        {template.type === 'my-block' && <div className="block-circle-myblock">M</div>}
      </div>
      <div className="block-image">
        <img src={blockImageUrl} alt="" />
      </div>
      <div className="block-btn-bottom-right" />
    </div>
  </div>
  );
};

export default BlockItem;
